import LoginPage from './pages/login'
import HomePage from './pages/index'
import BatteryPage from './pages/battery'

export const routerConfig = [
  {
    path: '/login',
    component: LoginPage,
    needAuth: false,
  },
  {
    path: '/home',
    component: HomePage,
    needAuth: true,
  },
  {
    path: '/home/battery',
    component: BatteryPage,
    needAuth: true,
  },
]
